export default "__VITE_ASSET__BJqApU8C__"